import React from "react";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import classNames from "classnames";
import dictionary from "../../../dictionary";
import SelectIcon from "../Icons/SelectIcon";
import isDarkColor from "../../../utils/is-dark-color";

import styles from "./color.module.scss";

function Color(props) {
  const {content, current, onChange, name, compact} = props;
  return (
    <div className={classNames(styles.root, compact && styles.rootCompact)}>
      <div className={styles.content}>
        {content.map(({label, value, disabled}) => (
          <Tooltip key={value} title={disabled ? `` : dictionary.item[value]}>
            <span className={styles.buttonContainer}>
              <button
                disabled={disabled}
                className={
                  current === value && isDarkColor(label)
                    ? classNames(styles.item, styles.itemInverted)
                    : styles.item
                }
                style={{
                  backgroundColor: label,
                  borderColor: label === `#fbfbfb` ? `#c9cbcc` : `transparent`
                }}
                onClick={() => onChange(name, value)}
              >
                {current === value && <SelectIcon />}
              </button>
            </span>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}

Color.propTypes = {
  name: PropTypes.string,
  compact: PropTypes.bool,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default Color;
